import { LngLat } from 'maplibre-gl';

export type RectangleBounds = {
    maxLat: number;
    maxLng: number;
    minLat: number;
    minLng: number;
};

export function getBoundsFromPoints(start: LngLat, end: LngLat): RectangleBounds {
    return {
        maxLat: Math.max(start.lat, end.lat),
        maxLng: Math.max(start.lng, end.lng),
        minLat: Math.min(start.lat, end.lat),
        minLng: Math.min(start.lng, end.lng),
    };
}

export function translateBounds(bounds: RectangleBounds, lngOffset: number, latOffset: number): RectangleBounds {
    return {
        maxLat: bounds.maxLat + latOffset,
        maxLng: bounds.maxLng + lngOffset,
        minLat: bounds.minLat + latOffset,
        minLng: bounds.minLng + lngOffset,
    };
}
